



















import { defineComponent } from '@vue/composition-api';
import { BaseIcon, IconSize } from '../base-icon';

export default defineComponent({
  name: 'BaseBreadcrumbItem',
  components: { BaseIcon },
  props: {
    hideIcon: {
      type: Boolean,
      default: false,
    },
    dataExternal: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { IconSize };
  },
});
